import { Link } from "react-router-dom";
import { Radio, Users, MapPin, Wifi } from "lucide-react";
import { fmtTimeRange } from "@/lib/format";

const day = (d) => new Date(`${d}T12:00:00`);
const FORMAT = {
  online: [Wifi, "Online"],
  in_person: [MapPin, "In person"],
  hybrid: [Wifi, "Online + in person"],
};

const Row = ({ it }) => {
  const [Icon, label] = FORMAT[it.format] || FORMAT.online;
  const d = day(it.date);
  return (
    <Link to={it.watch_url && it.format !== "in_person" ? it.watch_url : it.url} data-testid={`media-schedule-item-${it.id}-${it.date}`}
      className="group min-w-0 flex items-center gap-4 sm:gap-5 bg-white rounded-2xl border border-[#E5E0D8] p-4 hover:border-[#144F75] hover:-translate-y-0.5 transition-[transform,border-color]">
      <div className="w-16 shrink-0 text-center rounded-xl bg-[#F5F1EA] py-2">
        <p className="text-[11px] uppercase tracking-[0.14em] text-[#D98E73] font-semibold">{d.toLocaleDateString([], { month: "short" })}</p>
        <p className="font-serif text-2xl text-[#1A242B] leading-none mt-0.5">{d.getDate()}</p>
        <p className="text-[11px] text-[#8FA89B] mt-0.5">{d.toLocaleDateString([], { weekday: "short" })}</p>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <span className={`inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide rounded-full px-2 py-0.5 ${it.type === "broadcast" ? "bg-[#D98E73]/15 text-[#B4664B]" : "bg-[#5C8A72]/15 text-[#3F6B55]"}`}>
            {it.type === "broadcast" ? <Radio size={11} /> : <Users size={11} />}{it.type === "broadcast" ? "Broadcast" : "Class"}
          </span>
          <span className="inline-flex items-center gap-1 text-xs text-[#4A5D6B] min-w-0 max-w-full"><Icon size={12} className="shrink-0" /><span className="truncate"> {label}{it.location_name ? ` at ${it.location_name}` : ""}</span></span>
        </div>
        <p className="font-medium text-[#1A242B] truncate group-hover:text-[#144F75]">{it.title}</p>
        <p className="text-sm text-[#8FA89B]">{fmtTimeRange(it.start_time, it.end_time)}{it.host ? ` · with ${it.host}` : ""}</p>
      </div>
    </Link>
  );
};

export const LiveSchedule = ({ items, limit }) => {
  const xs = limit ? items.slice(0, limit) : items;
  return <div className="grid md:grid-cols-2 gap-3" data-testid="media-schedule-list">{xs.map((it) => <Row key={`${it.id}-${it.date}`} it={it} />)}</div>;
};
